
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Farmstayinnagpur() {



  const cardData =
  {
    keyword: ' Farm Stay in Nagpur',
    heading:  'Woodland Escape: Farm Stay in Nagpur ',
    headingDescription: 'Woodland Escape Resort is the perfect farm stay in Nagpur District, offering an inviting retreat where you can enjoy rural charm, open fields and nature immersed comfort. Set amidst lush greenery and framed by tree-lined surroundings, the stay features cozy cottages, open lawns for relaxation or picnic-style lounging, and the chance to breathe in fresh country air just outside the city. Whether you’re planning a quiet weekend, a family gathering or a group getaway, Woodland Escape Resort blends the simplicity of farm-stay living with resort-style amenities and warm hospitality for an unforgettable countryside escape.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Farm Stay in Nagpur",
      "description": "Experience authentic rural life with a stay at a Nagpur farm. Enjoy fresh air, scenic fields, farm-to-table meals, and interactive farming activities. Perfect for families, couples, and nature enthusiasts seeking a break from city life."
    },
    {
      "name": "Nagpur Rural Farm Stay",
      "description": "Nagpur Rural Farm Stay offers guests the chance to experience traditional village life. Participate in farming activities, milking cows, harvesting crops, and cooking local cuisine, all while enjoying rustic, comfortable accommodations."
    },
    {
      "name": "Nagpur Eco Farm Stay",
      "description": "Nagpur Eco Farm Stay focuses on sustainable living. Stay in eco-friendly cottages, learn organic farming practices, composting, and gardening. Guests enjoy a nature-centric experience with minimal environmental impact."
    },
    {
      "name": "Nagpur Luxury Farm Stay",
      "description": "Combine comfort with countryside charm at Nagpur Luxury Farm Stay. Stay in premium cottages, enjoy private gardens, farm-to-table meals, and curated nature walks. Ideal for couples, families, and those seeking upscale rural experiences."
    },
    {
      "name": "Nagpur Family Farm Stay",
      "description": "Nagpur Family Farm Stay offers activities for all ages, including tractor rides, animal feeding, fruit picking, and outdoor games. Spacious family-friendly accommodations ensure a fun and memorable rural vacation."
    },
    {
      "name": "Nagpur Kids Friendly Farm Stay",
      "description": "Perfect for children, this farm stay includes educational farm activities, playgrounds, petting zoos, and interactive workshops. Kids learn about agriculture while enjoying safe outdoor fun."
    },
    {
      "name": "Nagpur Weekend Farm Stay",
      "description": "Nagpur Weekend Farm Stay is ideal for a short rural getaway. Guests can enjoy nature walks, farm activities, bonfires, and traditional meals over a relaxing weekend in the countryside."
    },
    {
      "name": "Nagpur Private Farm Stay",
      "description": "Nagpur Private Farm Stay offers secluded cottages and exclusive farm experiences for couples, families, or small groups. Guests can enjoy personalized farm activities, private dining, and serene surroundings."
    },
    {
      "name": "Nagpur Nature Farm Stay",
      "description": "Immerse yourself in the beauty of nature at Nagpur Nature Farm Stay. Surrounded by lush greenery, rivers, and hills, guests enjoy outdoor activities, guided nature walks, and eco-friendly living."
    },
    {
      "name": "Nagpur Adventure Farm Stay",
      "description": "Nagpur Adventure Farm Stay combines rural charm with outdoor activities. Guests can enjoy trekking, cycling, archery, and farm-based adventure games for a fun-filled countryside experience."
    },
    {
      "name": "Nagpur Riverside Farm Stay",
      "description": "Nagpur Riverside Farm Stay offers picturesque views by the river. Enjoy riverside walks, fishing, boating, and farm activities while staying in cozy cottages along the riverbank."
    },
    {
      "name": "Nagpur Hill Farm Stay",
      "description": "Set on scenic hills, Nagpur Hill Farm Stay provides panoramic views, hiking opportunities, and fresh hill air. Ideal for nature lovers seeking relaxation and rural adventure."
    },
    {
      "name": "Nagpur Booking Farm Stay",
      "description": "Easily book your stay at Nagpur Booking Farm Stay with online reservation options. Select from family, couple, or private farm cottages and plan a rural getaway with ease."
    },
    {
      "name": "Nagpur One Day Farm Stay",
      "description": "For those short on time, Nagpur One Day Farm Stay offers day packages including farm tours, hands-on activities, nature walks, and traditional meals, perfect for a refreshing day in the countryside."
    },
    {
      "name": "Nagpur Agritourism Stay",
      "description": "Nagpur Agritourism Stay combines tourism with agriculture. Guests can participate in farm workshops, learn about sustainable farming, enjoy farm-fresh food, and experience rural life firsthand."
    }
  ],
  "tableData": [
    ["- Farm Stay in Nagpur", "- Nagpur Rural Farm Stay"],
    ["- Nagpur Eco Farm Stay", "- Nagpur Luxury Farm Stay"],
    ["- Nagpur Family Farm Stay", "- Nagpur Kids Friendly Farm Stay"],
    ["- Nagpur Weekend Farm Stay", "- Nagpur Private Farm Stay"],
    ["- Nagpur Nature Farm Stay", "- Nagpur Adventure Farm Stay"],
    ["- Nagpur Riverside Farm Stay", "- Nagpur Hill Farm Stay"],
    ["- Nagpur Booking Farm Stay", "- Nagpur One Day Farm Stay"],
    ["- Nagpur Agritourism Stay", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Authentic Farm Stay Experience in Nagpur",
    "WhyChoosedescription": "Woodland Escape Resort offers a serene farm stay experience where guests can immerse themselves in nature and rural charm. Surrounded by lush fields and greenery, it’s perfect for families, couples, and groups seeking a rustic yet comfortable getaway."
  },
  {
    "WhyChooseheading": "Engaging Farm Activities",
    "WhyChoosedescription": "Guests can participate in hands-on farm activities such as planting, harvesting, feeding animals, and learning about sustainable farming practices. These experiences provide both fun and educational value for adults and children alike."
  },
  {
    "WhyChooseheading": "Comfortable and Cozy Accommodation",
    "WhyChoosedescription": "The resort features well-designed cottages and rooms that blend rustic charm with modern amenities. Guests enjoy a cozy stay while being close to farm fields, gardens, and nature trails."
  },
  {
    "WhyChooseheading": "Fresh and Organic Meals",
    "WhyChoosedescription": "Woodland Escape serves farm-fresh, locally sourced, and organic meals prepared with care. Guests can enjoy authentic flavors while knowing the ingredients are grown sustainably on-site or sourced locally."
  },
  {
    "WhyChooseheading": "Nature Walks and Scenic Surroundings",
    "WhyChoosedescription": "The resort is surrounded by green fields, orchards, and forested areas. Guests can enjoy peaceful nature walks, birdwatching, and exploring the scenic beauty of the farm and its surroundings."
  },
  {
    "WhyChooseheading": "Family-Friendly and Safe Environment",
    "WhyChoosedescription": "Woodland Escape Resort provides a secure environment with open spaces for children to play and families to bond. Guests can enjoy outdoor games, picnics, and leisure activities safely in the natural setting."
  },
  {
    "WhyChooseheading": "Accessible Yet Tranquil Location",
    "WhyChoosedescription": "Located conveniently in Nagpur, Woodland Escape Resort offers the charm of a countryside retreat without long travel. Guests can enjoy the calm and beauty of a farm stay while remaining accessible from the city."
  }
]
































  }

const faqData = [
  {
    question: "Why choose Jaanvi Fruit Farm Agro Tourism for a farm stay near Nagpur?",
    answer: "Jaanvi Fruit Farm Agro Tourism is a peaceful and nature‑immersed farm‑stay in Nagpur district, surrounded by fruit orchards and open green spaces—perfect for a getaway from the city."
  },
  {
    question: "How far is Jaanvi Fruit Farm Agro Tourism from Nagpur city?",
    answer: "The farm‑stay is approximately 45 km from Nagpur city, making it comfortably reachable for an overnight or weekend stay surrounded by nature. :contentReference[oaicite:1]{index=1}"
  },
  {
    question: "What accommodation and facilities does Jaanvi Fruit Farm Agro Tourism offer?",
    answer: "It offers charming cottages and a large villa amid orchards and green surroundings. Guests can enjoy farm‑fresh meals, nature walks, and relaxed outdoor spaces. :contentReference[oaicite:2]{index=2}"
  },
  {
    question: "Is Jaanvi Fruit Farm Agro Tourism suitable for families and groups seeking a farm‑stay experience?",
    answer: "Absolutely! Whether it’s families, groups of friends or couples, the farm‑stay offers a calm and safe environment with spacious outdoors, making it ideal for a nature‑stay near Nagpur. :contentReference[oaicite:3]{index=3}"
  },
  {
    question: "Does Jaanvi Fruit Farm Agro Tourism provide meals and activities aligned with farm‑stay living?",
    answer: "Yes. You’ll find farm‑fresh meals, relaxing walks among fruit trees, optional activities like outdoor games or animal‑friendly experiences, giving you the true feel of staying on a farm. :contentReference[oaicite:4]{index=4}"
  },
  {
    question: "How can we book Jaanvi Fruit Farm Agro Tourism for a farm‑stay near Nagpur?",
    answer: "You can contact the resort by phone or email (as provided on their website), or visit their website to check availability. Advance booking is advisable especially on weekends. :contentReference[oaicite:5]{index=5}"
  }
];

const testimonials = [
  {
    name: "Mr. & Mrs. Sharma, Nagpur",
    text: "We stayed at Jaanvi Fruit Farm Agro Tourism and loved the experience! The green orchards, calm ambiance and comfortable cottage made our stay memorable."
  },
  {
    name: "Ms. Ritu & Family, Nagpur",
    text: "A beautiful farm‑stay near Nagpur! The kids enjoyed the open space and we adults found true relaxation away from the city. Highly recommended!"
  }
];































      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const farmStaySchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Farm Stay in Nagpur",
  "image": "https://woodlandescape.com/assets/images/nagpur-farm-stay.jpg",
  "description": "Experience rural life and nature at our Farm Stay in Nagpur. Perfect for families, kids, couples, and adventure seekers, offering eco-friendly, luxury, and riverside stays.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "35"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/nagpur-farm-stay"
  }
};




  return (
    <div>
<Helmet>
  <title>Farm Stay in Nagpur | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Enjoy a unique rural experience at our Farm Stay in Nagpur. Ideal for families, kids, couples, and adventure seekers with eco-friendly, luxury, and riverside options." 
  />
  <meta 
    name="keywords" 
    content="Farm Stay in Nagpur, Nagpur Rural Farm Stay, Nagpur Eco Farm Stay, Nagpur Luxury Farm Stay, Nagpur Family Farm Stay, Nagpur Kids Friendly Farm Stay, Nagpur Weekend Farm Stay, Nagpur Private Farm Stay, Nagpur Nature Farm Stay, Nagpur Adventure Farm Stay, Nagpur Riverside Farm Stay, Nagpur Hill Farm Stay, Nagpur Booking Farm Stay, Nagpur One Day Farm Stay, Nagpur Agritourism Stay" 
  />
  <script type="application/ld+json">
    {JSON.stringify(farmStaySchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/55.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Farmstayinnagpur;